/**
 * Mock data for the operations "Ended Promotion" page — the shared
 * RunningCampaign template in its ended (historical) mode: the hero drops its
 * live glow and shows an "Ended on …" tag instead of Pause. The performance
 * KPIs are the promotion's final tallies, for the owner to analyse.
 * Temporary — remove when wired to an API (see docs/mock-data.md).
 */
import type { RunningCampaignData } from './types';

const ART = '/assets/marketing/campaign-spooky-1.png';

export const operationsEndedPromotionData: RunningCampaignData = {
  header: { title: 'Ended Promotion Details' },
  hero: {
    image: ART,
    title: 'Spring Jackpot Race',
    subtitle: 'A month-long jackpot race that re-engaged dormant players.',
    adSpend: { value: '214', label: 'Players engaged' },
    offering: { value: '$50k Prize Pool', label: 'Offering' },
    duration: { value: 'May 1 - May 31', label: 'Duration' },
    // Default end timestamp; the dispatcher overrides it with the clicked
    // promotion's own "Ended on" date.
    endedOn: 'May 31, 21:30',
  },
  performance: {
    kpis: [
      {
        id: 'activated-players',
        title: 'Activated players',
        subtitle: 'Reactivated (dormant to active)',
        today: { value: '0', change: '0%', changeType: 'decrease' },
        month: { value: '1,240', change: '+14%', changeType: 'increase' },
      },
      {
        id: 'turnover-increase',
        title: 'Turnover increase',
        subtitle: 'Extra money wagered by players',
        today: { value: '$0', change: '0%', changeType: 'decrease' },
        month: { value: '$214,500', change: '+22%', changeType: 'increase' },
      },
      {
        id: 'deposits-triggered',
        title: 'Deposits triggered',
        subtitle: 'Deposits prompted by the promotion',
        today: { value: '0', change: '0%', changeType: 'decrease' },
        month: { value: '1,520', change: '+18%', changeType: 'increase' },
      },
      {
        id: 'ggr-increase',
        title: 'GGR increase',
        subtitle: 'Gross Gaming Revenue uplift',
        today: { value: '$0', change: '0%', changeType: 'decrease' },
        month: { value: '$72,300', change: '+19%', changeType: 'increase' },
      },
    ],
  },
};

export default operationsEndedPromotionData;
